;(function() {
  'use strict'

  Service.$inject = ["glDialog"];
  angular.module('app.survey').factory('surveyGenerator', Service)

  /* @ngInject */
  function Service(glDialog) {
    return {
      manage: manage,
    }

    function manage(survey) {
      glDialog.show({
        template: [
          '<gl-dialog class="survey-generator__dialog">',
          '<survey-generator on-done="dialog.close()" on-cancel="dialog.cancel()" survey="survey" />',
          '</gl-dialog>',
        ].join(''),
        locals: { survey: survey },
      })
    }
  }
})()
